module.exports = __webpack_public_path__ + "img/icon-captcha.18dc787e.svg";